import { render, staticRenderFns } from "./posibles-bajas.vue?vue&type=template&id=86a762b6&"
import script from "./posibles-bajas.vue?vue&type=script&lang=js&"
export * from "./posibles-bajas.vue?vue&type=script&lang=js&"
import style0 from "./posibles-bajas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports